import { render, staticRenderFns } from "./SpecifiedCommercialTransaction.vue?vue&type=template&id=591d30e6&scoped=true&"
import script from "./SpecifiedCommercialTransaction.vue?vue&type=script&lang=js&"
export * from "./SpecifiedCommercialTransaction.vue?vue&type=script&lang=js&"
import style0 from "./SpecifiedCommercialTransaction.vue?vue&type=style&index=0&id=591d30e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591d30e6",
  null
  
)

export default component.exports